module.exports = __webpack_public_path__ + "img/Dass_Dikteren_Petter_Dass.0469580b.jpg";